import { Component, inject, input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { IconComponent } from '@app/shared/components';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-close',
    imports: [TranslatePipe, RouterModule, IconComponent],
    templateUrl: './close.component.html',
    styleUrl: './close.component.css',
    host: {
        class: 'admin-menu-close',
    },
})
export class CloseComponent {
    private readonly router = inject(Router);
    readonly testId = input<string>();

    closeClick() {
        this.router.navigate(['/', { outlets: { admin: null } }]);
    }
}
